const hasNesting = (obj) => Object.values(obj).some(e => typeof e === 'object')
const goodKeyValues = (obj) => Object.entries(obj).every(([k, v]) => typeof k === 'string' && typeof v === 'number')

// we shouldn't let bad data through to pulse-init
export function sanityCheckObject(obj) {
  if (typeof obj === 'string') throw new Error('writeExperimentData got a String')
  if (hasNesting(obj)) throw new Error('writeExperimentData got a nested object')
  if (!goodKeyValues(obj)) throw new Error('writeExperimentData found an object with bad key/value - should be { string: number }')
}

// { a: 123, b: 456 } -> [{ experiment: a, timestamp: 123 }, { experiment: b, timestamp: 456 }]
export const convertToExperimentStructure = (obj) => Object.entries(obj).map(([k, v]) => ({ experiment: k, timestamp: v }))

export function writeToExperiments(arr) {
  if (typeof window === 'undefined') return // bail if we're not on the client
  if (!Array.isArray(window.experiments)) window.experiments = []
  window.experiments.push(...arr)
}

export function writeExperimentData(experimentObject) {
  sanityCheckObject(experimentObject)
  const arrayToWrite = convertToExperimentStructure(experimentObject)
  writeToExperiments(arrayToWrite)
}
